import { render } from "./EpisodeNew.vue?vue&type=template&id=43e79a3b"
import script from "./EpisodeNew.vue?vue&type=script&lang=js"
export * from "./EpisodeNew.vue?vue&type=script&lang=js"
script.render = render

export default script